import styled from '@mui/material/styles/styled'
import TextField from '@mui/material/TextField'

export const OptionName = styled(TextField, {
  name: 'OptionName',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
}))
